import {
  FIELD_GROUP,
  hasSaved,
  sameValue,
  keepsVehicle,
  keepsRto,
} from "../utils/masterDrift";

/**
 * Which saved values an edited policy still holds on to.
 *
 * `savedSnapshot` is null when creating, so every answer is false there and the
 * form behaves exactly as it always did.
 *
 *  - keepVehicle / keepRto: the saved Make & Model / RTO is still the one on
 *    the form and the operator has not released it.
 *  - keeps(field): the field's group is kept, the policy has a saved value for
 *    it, and the form still holds that value (the operator has not typed over
 *    it). A guarded effect must then leave the field alone.
 */
export const useMasterDrift = (savedSnapshot, values) => {
  const keepVehicle = keepsVehicle(savedSnapshot, values?.makeModel);
  const keepRto = keepsRto(savedSnapshot, values?.rtoCityLocation);

  const keeps = (field) => {
    const group = FIELD_GROUP[field];
    if (!savedSnapshot || !group) return false;
    if (!(group === "vehicle" ? keepVehicle : keepRto)) return false;
    const saved = savedSnapshot[field];
    return hasSaved(saved) && sameValue(values?.[field], saved);
  };

  return { keepVehicle, keepRto, keeps };
};
